export default __webpack_public_path__ + "static/media/SCHEDULED_APPOINTMENT.b8f9014b.svg";